module.exports = __webpack_public_path__ + "img/40.94415e65.jpg";